import { renderEmptyStateMarkup } from './emptyStateMarkup';

/** Creates a recoverable Community list failure state without conflating it with an empty result. */
export function renderCommunityLoadError(retryLoad: () => void): HTMLElement {
	const template = document.createElement('template');
	template.innerHTML = renderEmptyStateMarkup({
		icon: 'inbox',
		title: "Couldn't load community ideas",
		subtitle: 'Check your connection and try again.',
		extraClass: 'community-load-error',
	});
	const host = template.content.firstElementChild as HTMLElement;
	const error = host.querySelector<HTMLElement>('.community-load-error') ?? host;
	const retry = document.createElement('button');
	retry.type = 'button';
	retry.className = 'btn btn-primary btn-sm';
	retry.textContent = 'Retry';
	retry.addEventListener('click', retryLoad);
	error.appendChild(retry);
	return host;
}
